(function () {
    'use strict';

    angular
        .module('app.application')
        .controller('ApplicationDashboardController', ApplicationDashboardController);

    /* @ngInject */
    function ApplicationDashboardController(
        $q,
        $uibModal,
        $state,
        logger,
        moment,
        applicationService) {

        //Private Variables
        var vm = this;
        var applicationModalOptions = applicationService.getModalOptions();

        //Public Variables
        vm.applications = [];
        vm.applicationType = applicationService.getApplicationTypes();
        vm.title = 'Application Dashboard';
        vm.loadingMessage = 'Loading ... ';
        vm.isFilterCollapsed = true;

        //Public Methods
        vm.getApplications = applicationService.getApplications;
        vm.addApplication = addApplication;
        vm.editApplication = editApplication;
        vm.viewOverview = viewOverview;
        vm.viewRoles = viewRoles;
        vm.setActive = setActive;
        vm.viewGroups = viewGroups;

        // Smart Table
        vm.tableConfig = configureTableActions();

        // DI / IOC / unit testing / mocking
        vm.applicationService = applicationService;

        //Activate Controller
        activate();

        function activate() {
            logger.info('Activated application Dashboard View');
        }

        function addApplication() {
            applicationModalOptions.controller = 'ApplicationAddController';
            var modalInstance = $uibModal.open(applicationModalOptions);

            modalInstance.result.then(function (newApplication) {
                vm.isLoading = false;
                vm.applications.unshift(newApplication);
            }, function () {
                logger.info('Application Add Modal dismissed at: ' + new Date());
            });
        }

        function editApplication(application) {
            applicationModalOptions.controller = 'ApplicationEditController';
            var modalInstance = $uibModal.open(angular.extend({
                resolve: {
                    application: function () {
                        return angular.copy(application);
                    }
                }
            }, applicationModalOptions));

            modalInstance.result.then(function (updatedApplication) {
                angular.extend(application, updatedApplication);
            }, function () {
                logger.info('Application Edit Modal dismissed at: ' + moment().format());
            });
        }

        function viewRoles(application) {
            $state.go('application.role', { ApplicationID: application.ApplicationId });
        }

        function viewGroups(application) {
            $state.go('application.group', { ApplicationID: application.ApplicationId });
        }

        function setActive(application) {
            application.IsActive = !application.IsActive;
            return applicationService.setActive(application)
                .then(function (result) {
                    if (result.status === 200) {
                        application = result.data;
                        logger.info('Application ' + (application.IsActive ? 'Activated' : 'Deactivated'), result);
                    } else {
                        logger.error('Error Updating IsActive Flag', result);
                    }
                });
        }

        function viewOverview(application) {
            $state.go('application.overview', { ApplicationID: application.ApplicationId });
        }

        function configureTableActions() {
            var tableConfig = applicationService.getTableConfig();
            tableConfig.actions = [
                {
                    name: '"Overview"',
                action: viewOverview,
                icon: '"fa-edit"',
                permission:'AUTHORIZED'
            },
            {
                name: '"Edit"',
                action: editApplication,
                icon: '"fa-edit"',
                permission: 'SSO:SysAdmin'
            },
            {
                name: '"View Roles"',
                action: viewRoles,
                icon: '"fa-eye"',
                permission: ['SSO:SysAdmin', 'SSO:AppAdmin']
            }/*,
            {
                name: 'View Groups',
                action: viewGroups,
                icon: 'fa-eye'
            }*/];
            return tableConfig;
        }
    }
})();
